// Footer.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations';
import './Footer.css';

function Footer() {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  const showDevCredit = pathname === '/contact';

  return (
    <footer className="site-footer">
      <p>
        © 2025 IdeaFarm AB, Org.nr 559321-1039
        <span className="footer-separator"> | </span>
        <Link to="/integritetspolicy">{t('footer.privacy', language)}</Link>
        <span className="footer-separator"> | </span>
        <Link to="/cookies">Cookies</Link>
        <span className="footer-separator"> | </span>
        <Link to="/kopvillkor">{t('footer.terms', language)}</Link>
      </p>

      {showDevCredit && (
        <p className="developer-credit">
          Developed by{' '}
          <a
            href="https://websitesbybrona.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            WebsitesByBrona
          </a>
        </p>
      )}
    </footer>
  );
}

export default Footer;
